export const process = state => state.processReducer.process;
